<!-- crud asignar url de la api URL="url de la api" titulo="un titulo para la pestaña de la pagina" [dato]="variable que contiene el formulario]-->
<app-formulario #ctrl URL="grupo/avanzar" titulo="Avanzar Grupo / Control Escolar" [dato]="dato"></app-formulario>

<!-- Menu principal "-->
<app-sistema-menu></app-sistema-menu>


<div class="contenedor columns " style="height:100%; ">
    <div class="column is-1 is-hidden-mobile menu-izquierda">

        <!-- Menu izquierda del modulo enviroment" -->
        <app-sistema-menu-aside></app-sistema-menu-aside>
    </div>
    <div class="column" style="padding:0px;">
        <div style="background: #FFF; border-radius: 1em; ">

            <!-- formulario -->
            <form name="form" novalidate [formGroup]="dato" (ngSubmit)="ctrl.enviar(false)">
                <section class="hero is-primary">
                    <div class="hero-body">

                        <!-- Opciones  -->
                        <app-formulario-opciones [ctrl]="ctrl" [id]="ctrl.dato.id"></app-formulario-opciones>
                    </div>
                </section>
                <div id="banner" align="center" *ngIf="ctrl.cargando || cargarDatosCatalogo">
                    <div class="bloquear-azul">

                    </div>
                    <span class="tag is-primary is-large " style="position: absolute; top: 45%; font-size: 2em; z-index: 999999999;  left: 45%;">
            <span class="icon">
              <i class="fa fa-refresh fa-spin"></i>
            </span> &nbsp;
                    <span>Cargando...</span>
                    </span>
                </div>
                <section class="section" style="padding: 1rem !important; overflow:auto; height: 85.8vh;">
                    <!-- cargar los catalogos que se requieran parametro 1 modelo donde se guarda el catalogo, parametro 2 ruta de la api -->
                    <a id="catalogos" (click)="ctrl.cargarCatalogo('periodos_escolares_vigentes', 'periodo-escolar-vigente');"></a>
                    <a id="cargar-grupo" (click)="cargar_grupo('periodo-escolar');"></a>
                    <a id="message" (click)="ctrl.mostrar_mensaje(titulo, mensaje, clase);"></a>

                    <div class="columns">
                        <div class="column is-12">
                            <div class="control has-icons-left has-icons-right">
                                <label class="label">Periodo escolar:</label>
                                <ng-select2 [ngClass]="{'is-danger': ctrl.dato.get('periodos_escolares_id').hasError('required')}" [disabled]="ctrl.periodos_escolares_vigentes ? ctrl.periodos_escolares_vigentes.length == 0 ? true : false : true" name="periodos_escolares_id" [options]="ctrl.optionSelect"
                                    [value]="ctrl.dato.controls.periodos_escolares_id.value" [data]="ctrl.periodos_escolares_vigentes" (valueChanged)="ctrl.seleccionarValorSelect2($event, ctrl.dato.controls.periodos_escolares_id, '','', 'cargar-grupo');">
                                </ng-select2>

                                <span class="icon is-small is-right" *ngIf="ctrl.dato.get('periodos_escolares_id').hasError('required')">
                  <i class="fa fa-warning"></i>
                </span>
                                <span class="help is-danger" *ngIf="ctrl.dato.get('periodos_escolares_id').hasError('required')">Este
                  campo es requerido.</span>
                            </div>
                        </div>
                    </div>

                    <div class="box" *ngIf="ctrl.dato.controls.grupos.controls.length > 0">
                        <article class="media">
                            <div class="media-content">
                                <nav class="level">
                                    <div lass="level-left">
                                        <div class="level-item">
                                            <p align="center">
                                                <span class="icon has-text-info">
                          <i class="icon-community fa-3x"></i>
                        </span> &nbsp;&nbsp;
                                                <span *ngIf="periodo.periodos_siguientes==null"><strong>No se puede avanzar los grupos hasta que
                            agrege un nuevo periodo
                            escolar que continue al periodo: {{periodo.nombre}}</strong></span>
                                                <span *ngIf="periodo.periodos_siguientes!=null">
                          Los grupos se avanzarán al periodo escolar:
                          <strong>{{nuevo_periodo.nombre}}</strong>, fecha de inicio:
                          <strong>{{nuevo_periodo.fecha_inicio}}</strong> y fin:
                          <strong>{{nuevo_periodo.fecha_fin}}</strong>
                        </span>
                                            </p>
                                        </div>
                                    </div>

                                </nav>

                                <div class="content" style="overflow-y:auto;height: 58vh;">

                                    <table class="table is-striped is-fullwidth" style="width:100%;" formArrayName="grupos">
                                        <thead>
                                            <tr>
                                                <th>#</th>
                                                <th>Clave</th>
                                                <th>Actual</th>
                                                <th>Siguiente</th>
                                                <th>Limite</th>
                                                <th>Carrera</th>
                                                <th>T. Periodo</th>
                                                <th>
                                                    <div class="b-checkbox is-info" style="margin-left:5px">
                                                        <input id="cambiarAll" name="cambiarAll" class="styled" type="checkbox" [(ngModel)]="cambiarAll" [checked]="cambiarAll" (change)="checkAll()" [ngModelOptions]="{standalone: true}">
                                                        <label for="cambiarAll" style="font-weight:bold; font-size:large;">
                              Avanzar?
                            </label>
                                                    </div>
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr *ngFor="let val of ctrl.dato.controls.grupos.controls; let i = index;" [formGroupName]="i">
                                                <th>{{i + 1}}</th>
                                                <td><label for="avanzar{{i}}" style="font-weight:bold; font-size:large;">{{val.get('clave').value}}
                            {{val.get('nivel').value}} {{val.get('identificador').value}}</label></td>
                                                <td>{{val.get('nivel').value}}</td>
                                                <td>{{val.get('nivel_siguiente').value}}</td>
                                                <td>{{val.get('nivel_tope').value}}</td>
                                                <td>{{val.get('carrera').value}}</td>
                                                <td>{{val.get('tipo_periodo').value}}</td>
                                                <td>
                                                    <div *ngIf="val.get('nivel_siguiente').value <= val.get('nivel_tope').value" class="b-checkbox is-info" style="margin-left:5px">
                                                        <input id="avanzar{{i}}" name="avanzar{{i}}" class="styled" type="checkbox" formControlName="avanzar" [checked]="val.get('avanzar').value == 1 ? true : false">
                                                        <label for="avanzar{{i}}" style="font-weight:bold; font-size:large;">
                            </label>
                                                    </div>
                                                    <i *ngIf="val.get('nivel_siguiente').value > val.get('nivel_tope').value" title="No es posible avanzar este grupo, porque alcanzó su nivel máximo" class="icon-padlock fa-2x has-text-info"></i>

                                                </td>
                                            </tr>
                                            <tr *ngIf="ctrl.dato.controls.grupos.length==0">
                                                <td style="text-align:center;" colspan="8">
                                                    <h3>Sin resultados</h3>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>

                                </div>
                            </div>
                        </article>
                    </div>
                </section>
            </form>
        </div>
    </div>
</div>